<template>
  <section>
    <Dialog  :visible.sync="displayPosition"  :style="{width: '100vw'}" :position="position" :modal="true">
           <p class="ttl text-center" style="font-size:20px">So, What are you looking for today?</p>
            <!-- <input class="search__input search-bar__input"  type="search" placeholder="Search by keywords or #"/>
             -->

<AutoComplete class="search__input search-bar__input" v-model="items" filterMatchMode='contains' id="itm" placeholder="Search by keywords or #"
                          :suggestions="filteredItems" @complete="searchItem($event)" style="min-width: 100%;border: 0px solid #ced4da;"
                          field="name" ref="itm">
              <!-- <template #item="slotProps">
                <div style="font-size: 12px !important;">{{ slotProps.item.name }} - {{ slotProps.item.itemCode }}</div>
              </template> -->
            </AutoComplete>
          <DataView :value="itemMasterListByItem" :paginator="true" :lazy="true" style="width: 100%;" :rows="28"
                      :layout="layout">
              <template #grid="slotProps">
                <br/>
                <div class="p-col-12 p-md-1" style="border-bottom: 0px solid #c8c8c8;margin: 0px 36px 0px 0px;">
                  <!-- <div class="productList"> -->
                    <!-- <div class="grid__item small--one-half medium--one-third large-up--one-quarter"> -->
                      <!-- <div class="grid-view-item style1 wow fadeIn"> -->
                        <div class="">
                          <a href="">
                            <img @click="viewProductDetailsPage(slotProps.data)" :src="slotProps.data.singleImageUrl"
                                 :alt="slotProps.data.name" style="height: 150px;width: 110%;"/></a>
                          <!-- <div class="grid-view-item__title">{{ slotProps.data.name }}</div>
                           -->
                           <span class="title">{{ slotProps.data.name }}</span>
                          <span class="money bacurr-money" style="font-weight: 700;">Nrs.{{ slotProps.data.salesRate }}</span>
                        </div>
                      <!-- </div> -->
                    <!-- </div> -->
                  <!-- </div> -->
                </div>
              </template>
              <template #list="slotProps">
                <div class="p-col-12 p-md-1" style="border-bottom: 0px solid #c8c8c8;">
                  <div class="productList">
                    <div class="list__item small--one-half medium--one-third large-up--one-quarter">
                      <div class="list-view-item style1 wow fadeIn">
                        <div class="list-view-items">
                          <a href="">
                            <img @click="viewProductDetailsPage(slotProps.data)" :src="slotProps.data.singleImageUrl"
                                 :alt="slotProps.data.name" style="height: 300px;width: 85%;"/></a>
                          <div class="list-view-item__title">{{ slotProps.data.name }}</div>
                          <span class="product-price__price">NRs.{{ slotProps.data.salesRate }}</span>
                          <div class="product-description">{{ slotProps.data.description }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </DataView>

        </Dialog>
      <div id="shopify-section-header" class="shopify-section">
        <div class="top-header small--hide b-gutter-size clearfix uppercase">
          <div class="grid--table grid--no-gutters">
            <div class="grid__item top_left">
              <div class="top-header_left-text">
                <p><a href="mailto:talk.lilpicks@gmail.com">
                  <i class="ad ad-envelope-l"></i> Talk.lilpicks@gmail.com</a></p></div>
            </div>
            <div class="grid__item top_right text-right">
              <div>
            <span class="user-menu"><i class="ad ad-user-al" aria-hidden="true"></i>
            </span>
                <ul class="customer-links list-inline">
                  <li><a href="/account/login">Login</a></li>
                  <li>
                    <a href="/account/createAccount"> Create Account</a></li>
                  <li><a href="">Wishlist</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="hello">
          <div style="float: left;">

              <span> <a href="" target="_blank"><img  style="width: 23%;" src="/static/img/web/woollyfeltlogo-2.png"  alt="woolly" /></a> </span>
          </div>
<div class="menu">
<div class="menu-item">
  <div class="menu-text">
    <router-link to="/home" >
          <a href="#">Home</a>
        </router-link>
  </div>
</div>
<div class="menu-item">
  <div class="menu-text">
   <router-link to="/shop" >
          <a href="#">Shop</a>
        </router-link>
  </div>
</div>
<div class="menu-item menu-center">
  Kylie Ying
</div>
 <div class="menu-item">
  <div class="menu-text">
    <router-link to="/wishlist" >
          <a href="#">WishList</a>
        </router-link>
  </div>
</div>
<div class="menu-item">
  <div class="menu-text">
    <router-link to="/aboutUs" >
          <a href="#">About Us</a>
        </router-link>
  </div>
</div>

</div>
</div> -->
      <div class="header-wrap" data-section-id="header" data-section-type="header-section">
        <header class="site-header b-gutter-size logo--left" role="header">
          <div class="navBarCol large-up--hide">
            <button type="button" class="btn--link js-mobile-nav-toggle mobile-nav--open">
              <i class="ad hicon ad-bars-r"></i><i class="ad hicon ad-times-l"></i></button>
            <div class="my-account">
              <span class="user-menu"><i class="ad ad-user-al" aria-hidden="true"></i></span>
              <ul class="customer-links list-inline">
                <li>
           <router-link to="/account/customerLogin" >
                <a href="#">LogIn</a>
              </router-link>
              </li>
              <li>
           <router-link to="/account/createCustomer" >
                <a href="#">Create Account</a>
              </router-link>
              </li>
                <!-- <li><a href="/account/register"> Create Account</a></li> -->
                <li><a href="">Wishlist</a></li>
              </ul>
            </div>
          </div>
          <h1 class="site-header__logo">
            <a href="http://lilpicks.com.np/" itemprop="url" class="site-header__logo-image" style="max-width:285px;">
              <img style="width: 50%;margin-left: -25%;" src="/static/img/web/lillogo.png"
                   srcset="//cdn.shopify.com/s/files/1/0457/7519/2217/files/lilpicks-logo_7df7af98-ceb4-4201-9fc7-7893a41ce9ac_500x@2x.png?v=1599162483 1x, //cdn.shopify.com/s/files/1/0457/7519/2217/files/lilpicks-logo_7df7af98-ceb4-4201-9fc7-7893a41ce9ac.png?v=1599162483 1.1x"
                   alt="Lilpicks" itemprop="logo"></a>
          </h1>
          <nav id="AccessibleNav" role="navigation">
            <ul id="siteNav" class="site-nav regular center hidearrow">
              <li class="lvl1"><a href="/">Home</a>
              </li>
              <li class="lvl1 parent dropdown">
                <a href="" @click="viewProductByGroupId(603, 'group')">Boys Wear <i class="ad ad-angle-down-l">
                </i></a>
                <ul class="dropdown">
                  <li><a href="" class="site-nav" @click="viewProductByGroupId(528, 'subGroup')">Summer Wear</a></li>
                  <li><a href="" class="site-nav" @click="viewProductByGroupId(529, 'subGroup')">Autumn Winter Wear</a></li>
                  <li>
                    <a href="" class="site-nav" @click="viewProductByGroupId(530, 'subGroup')">Party Wear</a></li>
                  <li>
                    <a href="" class="site-nav" @click="viewProductByGroupId(540, 'subGroup')">Ethnic Wear<i class="ad ad-angle-right-l">
                    </i></a>
                    <ul>
                      <!-- <li><a href="" class="site-nav" @click="viewProductByGroupId(530, 'subGroup')">All Products</a></li> -->
                      <li>
                        <a href="" class="site-nav"
                           @click="viewProductByGroupId(531, 'subGroup')">Kurta Sets</a></li>
                      <li>
                        <a href="" class="site-nav" @click="viewProductByGroupId(532, 'subGroup')">Nehru Jackets</a></li>
                      <li>
                        <a href="" class="site-nav" @click="viewProductByGroupId(533, 'subGroup')">Dhoti Sets</a></li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li class="lvl1 parent dropdown">
                <a href="" @click="viewProductByGroupId(604, 'group')">Girls Wear <i class="ad ad-angle-down-l">
                </i></a>
                <ul class="dropdown">
                  <li><a href="" class="site-nav">Summer Wear<i class="ad ad-angle-right-l">
                  </i></a>
                    <ul>
                      <!-- <li><a href="" class="site-nav" @click="viewProductByGroupId(530, 'subGroup')">All Products</a></li> -->
                      <li><a href="" class="site-nav" @click="viewProductByGroupId(534, 'subGroup')">Jumpsuits</a></li>
                      <li><a href="" class="site-nav" @click="viewProductByGroupId(535, 'subGroup')">Clothing Sets</a></li>
                      <li><a href=""  class="site-nav" @click="viewProductByGroupId(536, 'subGroup')">Dresses</a></li>
                      <li><a href="" class="site-nav" @click="viewProductByGroupId(537, 'subGroup')">Tops & Bottoms</a></li>
                    </ul>
                  </li>
                  <li><a href="" class="site-nav" @click="viewProductByGroupId(538, 'subGroup')">Autumn Winter Wear</a>
                  </li>
                  <li><a href="" class="site-nav" @click="viewProductByGroupId(539, 'subGroup')">Party Wear</a></li>
                  <li><a href="" class="site-nav" @click="viewProductByGroupId(540, 'subGroup')">Ethnic Wear<i
                    class="ad ad-angle-right-l"></i></a>
                    <ul>
                      <!-- <li><a href="" class="site-nav" @click="viewProductByGroupId(530, 'subGroup')">Explore All</a></li> -->
                      <li><a href="" class="site-nav" @click="viewProductByGroupId(541, 'subGroup')">Sharara Sets</a>
                      </li>
                       <li><a href="" class="site-nav" @click="viewProductByGroupId(542, 'subGroup')">Lehenga Sets</a>
                      </li>
                      <li><a href="" class="site-nav"
                             @click="viewProductByGroupId(542, 'subGroup')">Lehenga Sets</a></li>
                      <li><a href="" class="site-nav" @click="viewProductByGroupId(543, 'subGroup')">Dhoti Sets</a></li>
                      <li><a href="" class="site-nav" @click="viewProductByGroupId(544, 'subGroup')">Shrug Sets</a></li>
                      <li><a href="" class="site-nav" @click="viewProductByGroupId(545, 'subGroup')">Palazzo Sets</a></li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li class="lvl1"><a href="" @click="viewProductByGroupId(605, 'group')">Baby Wear </a></li>
              <li class="lvl1"><a href="" @click="viewProductByGroupId(606, 'group')">Sibling Sets </a></li>
              <li class="lvl1"><a href="" @click="viewProductByGroupId(607, 'group')">Night Wear </a></li>
            </ul>
          </nav>

          <Button icon="pi pi-search" @click="openPosition('top')" style="background: #f0f1f3;border: 0px solid #eceff1;margin: 0% 1%;"
                  class="p-button-rounded">


          </Button>
          <Button icon="pi pi-shopping-cart" @click="$router.push('cart')"
                  style="background: #f0f1f3;border: 0px solid #eceff1;" class="p-button-rounded">


          </Button>

        </header>
      </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import DatePicker from 'vue2-datepicker'
import Carousel from 'primevue/carousel'
import Galleria from 'primevue/galleria'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import TextArea from 'primevue/textarea'
import Dialog from 'primevue/dialog'
import DataView from 'primevue/dataview'

export default {
  name: 'website',
  props: ['website'],
  data() {
    return {
      name: '',
      layout: 'grid',
      items: '',
      sortOrder: null,
      filteredItems: null,
      sortField: null,
      displayPosition: false,
      position: '',
      itemMasterListByItemType: [],
      itemMasterListByItem: [],
      sortOptions: [
        {label: 'Price High to Low', value: '!price'},
        {label: 'Price Low to High', value: 'price'}
      ]
    }
  },
  computed: {},
  mounted() {
    this.itemMasterListByItemTypes()
  },
  methods: {
    async viewProductByGroupId(id, typ) {
      let PIHdata = {
        id: id,
        type: typ
      }
      this.$router.push({name: 'collections', params: {collections: PIHdata}, query: {item: id, typ: PIHdata.type}})
    },
    async viewProductDetailsPage(data) {
      let PIHdata = {
        id: data.id,
        itemName: data.name,
        imgUrl: data.singleImageUrl,
        sellingPrice: data.salesRate,
        description: data.description,
        itemCode: data.itemCode,
        groupName: data.groupName,
        images: data.imageList
      }
      this.$router.push({name: 'Product Detail', params: {productObject: PIHdata}, query: {item: PIHdata.id}})
    },
    openPosition(position) {
      this.position = position
      this.displayPosition = true
    },
    closePosition() {
      this.displayPosition = false
    },
    searchItem(event) {
      // this.itemMasterListByItemTypes()
      setTimeout(() => {
        if (!event.query.trim().length) {
          // this.itemMasterListByItem = [...this.itemMasterListByItemType]
        } else {
          // this.itemMasterListByItem = this.itemMasterListByItemType.filter(item)
          this.itemMasterListByItem = this.itemMasterListByItemType.filter((item) => {
            // this.itemPropertyValuesDTOList = item.itemPropertyMasterList
            return item.name.toLowerCase().includes(event.query.toLowerCase()) || item.itemCode.includes(event.query)
          })
        }
      }, 250)
    },
    async itemMasterListByItemTypes() {
      // await this.$store.dispatch('loadItemMasterListForSite')
      let response = await this.$store.dispatch('loadItemMasterListForSite')
      this.itemMasterListByItemType = response.data.data
    }
  },
  components: {
    Dropdown,
    DatePicker,
    Checkbox,
    AutoComplete,
    InputNumber,
    InputMask,
    Button,
    InputText,
    TextArea,
    Carousel,
    Galleria,
    Dialog,
    DataView
  }
}
</script>
<style scoped src="@../../../static/css/website.css">
.p-inputtext {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 1rem;
    color: #495057;
    background: #ffffff;
    padding: 0.5rem 0.5rem;
    border: 0px solid #ced4da;
    transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
    appearance: none;
    border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// website.vue?ad7441e2